import { defineComponent } from 'vue';
export default defineComponent({
  name: 'progress',
  data() {
    return {};
  },
  props: {
    progress: {
      default: 0,
      type: Number
    }
  },
  methods: {}
});